import * as React from 'react';
import { useContext } from 'react';

import { Modal } from '../../../shared/Modal';
import { EventInfoContext } from '../../../event';

export const ErrorDetailModal =
  React.memo(({ errorDescription, active }: { errorDescription: String, active: boolean}) => {
    const { updateError } = useContext(EventInfoContext);
    return (
      <Modal active={active} showDarkOverlay>
        <div className="ui-popup-container ui-popup-active">
          <div className="ui-content ui-popup ui-body-inherit ui-overlay-shadow ui-corner-all">
            <div className="error-details">
              {errorDescription}
            </div>
            <div className="error-footer">
              <button type="button" className="button-cancel" data-role="none" onClick={() => updateError('')}>Close</button>
            </div>
          </div>
        </div>
      </Modal>
    );
  });
